import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'curruncyFixed'
})
export class CurruncyFixedPipe implements PipeTransform {
  result: string = "";
  transform( pvalue: number ): string | null {

    if(pvalue){
      var values = (pvalue + "").split(".");
      var fixedTotal = 0;
      if(values[1] != undefined){
        
        fixedTotal =(values[1].toString()).length;
        if(fixedTotal >= 1){
          fixedTotal = 2;
        }
        
      }
      
      this.result = pvalue.toFixed(fixedTotal);
    }
    else{
      this.result = "0";
    }
    

    return this.result
  }

}
